var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    style: { backgroundSize: _vm.backgroundSize },
    attrs: {
      type: "range",
      min: _vm.min,
      max: _vm.max,
      step: _vm.step,
      disabled: _vm.disabled,
    },
    domProps: { value: _vm.form },
    on: { input: ({ target }) => (_vm.form = parseFloat(target.value)) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }